import debounce from 'debounce-promise';
import { useFormikContext } from 'formik';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';

interface AutoSaveProps {
  debounceMs: number;
  showLastSaveMessage?: boolean;
}

const AutoSave = ({ debounceMs, showLastSaveMessage = false }: AutoSaveProps) => {
  const didMount = useRef(false);
  const formik = useFormikContext();
  const [lastSaved, setLastSaved] = useState<string>('');
  const debouncedSubmit = useMemo(
    () =>
      debounce(
        () => formik.submitForm().then(() => setLastSaved(moment().format('lll'))),
        debounceMs
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debounceMs, formik.submitForm]
  );

  useEffect(() => {
    // to prevent from saving on load, check that page has been loaded
    if (didMount.current) {
      debouncedSubmit();
    } else {
      didMount.current = true;
    }
  }, [debouncedSubmit, formik.values]);

  return (
    <>
      {!showLastSaveMessage
        ? null
        : formik.isSubmitting
        ? 'Saving...'
        : lastSaved !== null
        ? `Last saved: ${lastSaved}`
        : null}
    </>
  );
};

export default AutoSave;
